export default __webpack_public_path__ + "static/media/9.e00dadd2.png";